__turbopack_context__.v({
  "actions": "ZKvWrq_actions",
  "actionsContainer": "ZKvWrq_actionsContainer",
  "addAlertButton": "ZKvWrq_addAlertButton",
  "alertButtons": "ZKvWrq_alertButtons",
  "alertLabel": "ZKvWrq_alertLabel",
  "alertRuleContent": "ZKvWrq_alertRuleContent",
  "alertRuleHeader": "ZKvWrq_alertRuleHeader",
  "alertRuleText": "ZKvWrq_alertRuleText",
  "alertRuleTitleIndex": "ZKvWrq_alertRuleTitleIndex",
  "alertRuleWrapper": "ZKvWrq_alertRuleWrapper",
  "infoTooltip": "ZKvWrq_infoTooltip",
  "moreOptions": "ZKvWrq_moreOptions",
  "moreOptionsList": "ZKvWrq_moreOptionsList",
  "moreOptionsListItem": "ZKvWrq_moreOptionsListItem",
  "section": "ZKvWrq_section",
});
